import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { Box, Stack, Text } from '@eneco/sparky';
import { InfoIcon } from '@eneco/sparky/icons';

interface Props {
  text: string;
  trigger: string;
  topic: string;
}

const ChatActivator: FC<Props> = ({ text, trigger, topic }) => {
  const chatActivatorText = `<button data-chattopic="${topic}">${trigger}</button>`;
  return (
    <Box>
      <Text>{text}</Text>
      <Stack direction="row" alignY="center" gap="1">
        <InfoIcon size="small" />
        <RichText html={chatActivatorText} />
      </Stack>
    </Box>
  );
};

export default ChatActivator;
